import { render, staticRenderFns } from "./FinancialDisclosures.vue?vue&type=template&id=14f7d2a4&"
import script from "./FinancialDisclosures.vue?vue&type=script&lang=js&"
export * from "./FinancialDisclosures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports